import React from "react";
import {Form, Input, InputNumber, message, Select,Tooltip,Icon} from 'antd';
import NHFormItem from '../common/NHFormItem';
import NHFetch from "../../utils/NHFetch";
import NHSelect from '../common/NHSelect/index'
import NHInputPicker from '../common/NHInputPicker/index';

const FormItem = Form.Item;
const basicUrl = "/sjhmwh/";

/**
 * @author yangqizhi
 * @Description: 手机号码编辑表单
 */
class EditForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            yysSelectData: [],  // 运营商下拉选择框数据
            sjh : '',           // 手机号
            pxh: 0              // 排序号
        }
    }

    static defaultProps = {
        initFormData: {
            pkid: '',
            yys: '',
            sjh: '',
            pxh: 0,
            isUpdate: false
        }
    };

    componentDidMount() {
        NHFetch(basicUrl + "getYysDataSource", "GET")
            .then(resData => {
                if (resData.data) {
                    this.setState({
                        yysSelectData: resData.data,
                    })
                } else {
                    message.error("获取运营商数据失败！")
                }
            })
    }

    render() {
        const {form} = this.props;
        const initData = this.props.initFormData;
        const {yysSelectData} = this.state;
        let yysOptions = [];
        if (yysSelectData) {
            yysOptions = yysSelectData.map((item, index) => 
            <Select.Option key={index} value={item.VALUE}>{item.LABEL}</Select.Option>);
        }

        return (
            <div>
                <Form layout="horizontal">
                    <NHFormItem id={'yys'} label={'通讯运营商'} hasFeedback={true} form={form} required={true}
                                initialValue={initData.yys ? initData.yys : 
                                (initData.isUpdate ? "" : 
                                (yysSelectData.length > 0 ? yysSelectData[0].VALUE : ""))}>
                        <Select placeholder='请选择...'>
                            {yysOptions}
                        </Select>
                    </NHFormItem>
                    <NHFormItem id={'sjh'} label={'手机号码'} hasFeedback={true} form={form} required={true}
                            pattern={{ pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码！'}}
                            initialValue={initData.sjh}>
                        <Input placeholder="请输入手机号码"/>
                    </NHFormItem>
                    <NHFormItem id={'pxh'} label={'排序号'} hasFeedback={true} form={form}
                                initialValue={initData.pxh?initData.pxh:0}>
                        <Input />
                    </NHFormItem>
                </Form>
            </div>
        );
    }
}

const editForm = Form.create()(EditForm);

export default editForm;



// WEBPACK FOOTER //
// ./components/sjhmwh/EditForm.js